import { render, staticRenderFns } from "./settingTaxRate.vue?vue&type=template&id=1c4a903d"
import script from "./settingTaxRate.vue?vue&type=script&lang=js"
export * from "./settingTaxRate.vue?vue&type=script&lang=js"
import style0 from "./settingTaxRate.vue?vue&type=style&index=0&id=1c4a903d&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4a903d')) {
      api.createRecord('1c4a903d', component.options)
    } else {
      api.reload('1c4a903d', component.options)
    }
    module.hot.accept("./settingTaxRate.vue?vue&type=template&id=1c4a903d", function () {
      api.rerender('1c4a903d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/components/settingTaxRate.vue"
export default component.exports